<template>
  <ul class="my-0 list-unstyled">
    <matches v-if="!isEmpty(matches)"
      :matches="matches"
      view="popover"
    />
    <li v-if="description" class="row-content row-content_text--tight">
      <span
        class="row-content--main"
        v-html="description"
        v-line-clamp="4"
      />
    </li>
  </ul>
</template>

<script>
import processing from '@/mixins/search/results/organisation'
import Matches from '@/components/search/results/partials/Matches'

export default {
  name: 'organisationResultPopover',
  mixins: [processing],
  components: {
    Matches
  },
  mounted () {
    if (!this.isEmpty(this.matches) || this.description) {
      this.$emit('setIsEmptyPopover', false)
    } else {
      this.$emit('setIsEmptyPopover', true)
    }
  }
}
</script>
